/* eslint-disable react/no-array-index-key */
import React, { useEffect } from 'react';
import StyledBox from 'common/components/SliderDots/SliderDots.styles';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { Box } from '@material-ui/core';
import { SliderDostsArrows } from 'common/components/SliderDots';

const responsive = {
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 5,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 5,
  },
};

const SliderDots = (props) => {
  const {
    slidesArray,
    responsiveStyle,
    getItemCurrentSlide = () => {},
    goToSlide,
    ...rest
  } = props;
  const {
    carouselState: { currentSlide },
  } = rest;
  const getSliderAdditionalTransfromValue = () => {
    let additionalTransfromValue;
    switch (currentSlide) {
      case 0:
        additionalTransfromValue = 1 * 5;
        break;
      case 1:
        additionalTransfromValue = 6 * 5;
        break;
      default:
        additionalTransfromValue = 11 * 5;
    }
    return additionalTransfromValue;
  };

  useEffect(() => {
    getItemCurrentSlide(currentSlide + 1);
  }, [currentSlide]);
  return (
    <>
      <StyledBox className="SDContiner">
        <Carousel
          arrows={false}
          additionalTransfrom={getSliderAdditionalTransfromValue()}
          renderButtonGroupOutside
          responsive={responsiveStyle || responsive}
          swipeable
          draggable
          customTransition="all 0.4s"
          containerClass="carousel-container"
          dotListClass="custom-dot-list-style"
          autoPlay={false}
          shouldResetAutoplay={false}
          customButtonGroup={
            slidesArray.length > 1 && (
              <SliderDostsArrows
                goToImage={goToSlide}
                currentImage={currentSlide}
                slidesArraySize={slidesArray.length}
              />
            )
          }
        >
          {slidesArray.map((item, index) => (
            <Box
              className={
                currentSlide === index ? 'SDSlideItem active' : 'SDSlideItem'
              }
              onClick={() => {
                goToSlide(index);
              }}
              key={index}
            />
          ))}
        </Carousel>
      </StyledBox>
    </>
  );
};
export { SliderDots };
